import { Helmet } from 'react-helmet';
import PageHeader from './Common/PageHeader';
const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>
          Our terms and conditions apply to all our customers at Bakumia{' '}
        </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="We have certain terms and conditions that you have to fulfill before shopping at Bakumia. Please read through the points here and click on the  agree option. "
        />
      </Helmet>
      <PageHeader title="Terms of Services" />
      <section className="policy-section py-3">
        <div className="container-fluid">
          <div className="text-center mb-5">
            <h2 className="fw-semibold">Terms of Services at Bakumia</h2>
            <div className="policy-divider"></div>
            <p className="text-muted mt-3">
              Please read our Terms of Services and Privacy Policy carefully
              before using Bakumia.pk.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Overview</h5>
            <p>
              Bakumia.pk will be referred to as the “site”, “company”, “we”, or
              the “website”. By using our website, you agree to these Terms of
              Services and all related policies.
            </p>
            <p>
              If you disagree with any part of these terms, you must not use our
              site.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Acceptance of Terms</h5>
            <p>
              You accept our services and terms by ticking the confirmation
              checkbox and clicking the “Continue” button during checkout. The
              company may revise these terms at any time, with updates posted on
              our website.
            </p>
            <p>
              All changes become effective immediately after posting. Please
              review regularly to avoid any inconvenience.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Notifications & Communication</h5>
            <p>
              We may send you emails about your account activity, purchases,
              promotions, or updates. You can unsubscribe from promotional
              emails anytime by clicking “Unsubscribe”.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Registration Requirement</h5>
            <p>
              You are required to register before making a purchase so that your
              information can be stored securely for future correspondence.
            </p>
          </div>

          <div className="policy-card">
            <h5 className="fw-bold mb-3">Terms of Services (While Buying)</h5>
            <ul>
              <li>
                Items can be exchanged if defective or incorrectly delivered.
              </li>
              <li>Delivery charges are paid by the customer.</li>
              <li>Exchange policy starts 7 days after delivery.</li>
              <li>Minimum order value is (insert value).</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
export default TermsAndConditions;
